import { cn } from '@/lib/utils';
import type { BillingInterval } from '@/hooks/useDynamicPricing';

interface BillingToggleProps {
  value: BillingInterval;
  onChange: (value: BillingInterval) => void;
  /** Number of free months (e.g., 2 for "Get 2 months free") */
  freeMonths?: number;
  className?: string;
}

export function BillingToggle({
  value,
  onChange,
  freeMonths = 2,
  className
}: BillingToggleProps) {
  return (
    <div className={cn('flex flex-col items-center gap-2', className)}>
      <div className="flex items-center justify-center gap-3">
        <button
          type="button"
          onClick={() => onChange('month')}
          className={cn(
            'px-4 py-2 rounded-full text-sm font-medium transition-all duration-200',
            value === 'month'
              ? 'bg-orange-500 text-white shadow-md'
              : 'bg-gray-100 text-gray-600 hover:bg-gray-200 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700'
          )}
        >
          Monthly
        </button>
        <button
          type="button"
          onClick={() => onChange('year')}
          className={cn(
            'px-4 py-2 rounded-full text-sm transition-all duration-200',
            value === 'year'
              ? 'bg-orange-500 text-white shadow-md font-semibold'
              : 'bg-gray-100 text-gray-600 hover:bg-gray-200 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 font-medium'
          )}
        >
          Annual
        </button>
      </div>
      {freeMonths > 0 && (
        <span className="text-xs text-gray-500 dark:text-gray-400 opacity-85">
          {freeMonths} months free with annual
        </span>
      )}
    </div>
  );
}
